module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/Cart.447aab61.svg";